var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white--text mx-5 my-2",staticStyle:{"position":"absolute","top":"0","z-index":"1"}},[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-arrow-left")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }